import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import React, { useLayoutEffect, useRef } from "react";
import styled from "styled-components";
import DrawSvg from "../DrawSvg";

const Section = styled.section`
  min-height: 100vh;
  width: 100vw;
  background-color: ${(props) => props.theme.body};
  position: relative;
  display: inline-block;
  overflow: hidden;
`;
const Title = styled.h1`
  font-size: ${(props) => props.theme.fontxxl};
  text-transform: capitalize;
  color: ${(props) => props.theme.text};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  border-bottom: 2px solid ${(props) => props.theme.text};
  width: fit-content;

  @media (max-width: 40em) {
    font-size: ${(props) => props.theme.fontxl};
  }
`;
const Container = styled.div`
  width: 70%;
  height: 200vh;
  background-color: ${(props) => props.theme.body};
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 64em) {
    width: 80%;
  }
  @media (max-width: 48em) {
    width: 90%;
  }
`;
const SvgContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Items = styled.ul`
  list-style: none;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: lightblue;

  @media (max-width: 48em) {
    width: 90%;
  }

  & > *:nth-of-type(2n + 1) {
    justify-content: start;
    @media (max-width: 48em) {
      justify-content: center;
    }

    div {
      border-radius: 50px 0 50px 0;
      text-align: right;

      @media (max-width: 48em) {
        border-radius: 0 50px 0 50px;
        text-align: left;
        p {
          border-radius: 0 40px 0 40px;
        }
      }
    }
    p {
      border-radius: 40px 0 40px 0;
    }
  }
  & > *:nth-of-type(2n) {
    justify-content: end;
    @media (max-width: 48em) {
      justify-content: center;
    }
    div {
      border-radius: 0 50px 0 50px;
      text-align: left;
    }
    p {
      border-radius: 0 40px 0 40px;
    }
  }
`;
const Item = styled.li`
  width: 100%;
  height: 100%;
  display: flex;

  @media (max-width: 48em) {
    justify-content: flex-end !important;
  }
`;
const ItemContainer = styled.div`
  width: 40%;
  height: fit-content;
  padding: 1rem;
  border: 3px solid #000;

  @media (max-width: 48em) {
    width: 70%;
  }
`;

const Box = styled.p`
  height: fit-content;
  background-color: #fff;
  color: ${(props) => props.theme.text};
  padding: 1rem;
  position: relative;
  border: 1px solid ${(props) => props.theme.text};
`;
const SubTitle = styled.span`
  display: block;
  font-size: ${(props) => props.theme.fontxl};
  text-transform: capitalize;
  color: #000;

  @media (max-width: 40em) {
    font-size: ${(props) => props.theme.fontlg};
    font-weight: 600;
  }
`;
const Text = styled.span`
  display: block;
  font-size: ${(props) => props.theme.fontsm};
  text-transform: capitalize;
  color: #000;

  font-weight: 400;
  margin: 0.5rem 0;
  @media (max-width: 40em) {
    font-size: ${(props) => props.theme.fontxs};
  }
`;

const RoadMapItem = ({ title, subtext, addToRef }) => {
  return (
    <Item ref={addToRef}>
      <ItemContainer>
        <Box>
          <SubTitle>{title} </SubTitle>
          <Text>{subtext}</Text>
        </Box>
      </ItemContainer>
    </Item>
  );
};

const Roadmap = () => {
  const revealRefs = useRef([]);
  revealRefs.current = [];
  gsap.registerPlugin(ScrollTrigger);

  const addToRefs = (el) => {
    if (el && !revealRefs.current.includes(el)) {
      revealRefs.current.push(el);
    }
  };

  useLayoutEffect(() => {
    let t1 = gsap.timeline();
    revealRefs.current.forEach((el, index) => {
      t1.fromTo(
        el.childNodes[0],
        {
          y: "0",
        },
        {
          y: "-30%",

          scrollTrigger: {
            id: `section-${index + 1}`,
            trigger: el,
            start: "top center+=200px",
            end: "bottom center",
            scrub: true,
            // markers:true,
          },
        }
      );
    });

    return () => {
      if (t1) t1.kill();
    };
  }, []);

  return (
    <Section id="roadmap">
      <Title>Roadmap</Title>
      <Container>
        <SvgContainer>
          <DrawSvg />
        </SvgContainer>
        <Items>
          <Item>&nbsp;</Item>
          <RoadMapItem
            addToRef={addToRefs}
            title="Grand Opening - Earth"
            subtext="The quality of all 1,111 NFTs has been ensured & it was one of challanging task to make it up to standard with 100% quality with unique traits and rarities."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="Community"
            subtext="Community is our heart. No matter what the cost is, we will always strive to provide the best value to our community & This will never end."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="Jungle Galaxy"
            subtext="The first galaxy they encounter is the Jungle Galaxy. In this galaxy there are several planets on which there is life. They meet there the self-proclaimed JungleRiderz. A squad of the best 3,333 football players."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="Partnership"
            subtext="We believe Web3 is an open world and We must hold each other's hands to make web3 a better place. As we are ready to help other artist, communities & contribute Web3 program So that will come with a benefit for all of us."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="Galexyz Coin"
            subtext="Our goal is to develop our own Galexyz coin which can be used for our Galexyz ecosystem. We want to use 70% of our future income for this."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="Marketplace"
            subtext="A platform that is yours. Where you can purchase Whitelist, Subscriptions, Claim Art, Comic & much more items only with our tokens in our marketplace."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="Staking"
            subtext="Galexyz holders who stake their NFTs are eligible to earn our token. Any item from our marketplace can be purchased with tokens."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="Comics Book"
            subtext="Who doesn’t love to read comics book? Since we already have a great story about a magical world to earth, a full story will be published with our comics."
          />
          <RoadMapItem
            addToRef={addToRefs}
            title="To Be Continued"
            subtext="We all know web3 is beginning of a new era and our future is beyond imagination, but all we can promise is, we will never stop building."
          />
        </Items>
      </Container>
    </Section>
  );
};

export default Roadmap;
